module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAS5JREFUKBWV0r1LQmEUx/Hb4CISYkjUH6GJBU7OjTnU0FKDWwSBIhGIkwgSOPkPREtENTQ4WoNRg6DQ4OLi4GCoRODQq99fPIov4NUDH8/zcs7D9d7HsmaHk+1r1BGeXTq+62L6iD+jSXbANpapKOEXF+jgBrbhpuIFaoxiG5uoYAUK1UyFh5UyfnCAY+ix7xBADTq4hx0Mw8uoim/sI4bB/1W+hx8ts94g/8cqv6/4wh5OMdqo8Tt8eIDm57DWocf5RARJTDZ2WQvh0uzlyUuwns3CLXkLelGjzW2zfmXWc+RhPDFSsZqOoDc8OOCNcRA6WDVZjMUaM33DE+h05UPoUmxAL0qNadiGPkUC+mwFqDGFuaJIlRo+TD6bq4si3V1dEjVLHAuFm+oMdu26+lWdVvS+Cey/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/ticket.png
// module id = 309
// module chunks = 0